import * as Ark from '@dateam/ark';
import httpService from 'utils/httpService';
import config from 'config';

export const get = async (): Promise<App.Area[]> => {
    let response;
    try {
        const requestUrl = Ark.stringFormat('{0}/area', config.apiUrl);

        response = await httpService.get<App.Area[]>(requestUrl, {});
    }
    catch (err) {
        const errMessage = (err instanceof Error && err?.message) || 'no further detail';
        throw new Error(`an error occurred while calling area API (${errMessage}})`);
    }

    if (response.status === -1) throw new Error('unable to send area request (get)');
    if (response.status === Ark.HttpStatusCode.Unauthorized) {
        throw new Ark.ServiceError('AREA_GET_UNAUTHORIZED');
    }
    if (response.status === Ark.HttpStatusCode.Forbidden) {
        throw new Ark.ServiceError('AREA_GET_FORBIDDEN');
    }

    if (Ark.isDefined(response.error)) {
        throw new Ark.ServiceError(
            response.error.code ?? 'AREA_GET_ERROR',
            response.error.message ?? undefined
        );
    }

    try {
        Ark.assert(response.jsonContent === true, 'excepted JSON data');
        Ark.assertIsArray(response.body, 'invalid request data');
    }
    catch (err) {
        throw new Ark.ServiceError('AREA_GET_ASSERTION_FAILED', (err instanceof Error && err?.message) || '');
    }

    return response.body;
};
